import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const links = [
  { label: "Philosophy", href: "#philosophy" },
  { label: "Services", href: "#services" },
  { label: "VIP", href: "#vip" },
  { label: "Contact", href: "#contact" },
];

export default function Nav() {
  const [visible, setVisible] = useState(true);
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let lastY = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 40);
      setVisible(y < lastY || y < 100);
      lastY = y;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <AnimatePresence>
        {visible && (
          <motion.header
            data-testid="site-nav"
            initial={{ y: -80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -80, opacity: 0 }}
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
              scrolled
                ? "backdrop-blur-2xl bg-onyx/70 border-b border-cream/5"
                : "bg-transparent"
            }`}
          >
            <div className="max-w-[1440px] mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
              <a href="#top" data-testid="nav-logo" className="flex items-center gap-1 group">
                <span className="logo-mark w-8 h-8 md:w-9 md:h-9">
                  <img src="/assets/logo-mark.png" alt="ऋ Design monogram" />
                </span>
                <span className="font-serif text-lg md:text-xl text-cream tracking-tight -ml-0.5">
                  -design
                </span>
              </a>

              <nav className="hidden md:flex items-center gap-10">
                {links.map((l) => (
                  <a
                    key={l.href}
                    href={l.href}
                    data-testid={`nav-link-${l.label.toLowerCase()}`}
                    className="link-underline text-[11px] font-sans font-medium tracking-overline uppercase text-cream/70 hover:text-brass transition-colors"
                  >
                    {l.label}
                  </a>
                ))}
              </nav>

              <a
                href="#contact"
                data-testid="nav-cta"
                className="hidden md:inline-flex items-center gap-2 text-[11px] font-sans font-medium tracking-overline uppercase text-onyx bg-cream hover:bg-brass transition-colors duration-500 px-5 py-3"
              >
                Request Consultation
                <span aria-hidden>→</span>
              </a>

              <button
                data-testid="nav-menu-toggle"
                onClick={() => setOpen((v) => !v)}
                className="md:hidden text-[11px] tracking-overline uppercase text-cream font-medium"
              >
                {open ? "Close" : "Menu"}
              </button>
            </div>
          </motion.header>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-40 bg-onyx pt-24 px-6 md:hidden"
          >
            <div className="flex flex-col gap-8">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="font-serif text-4xl italic text-cream"
                  data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                >
                  {l.label}
                </a>
              ))}
              <a
                href="#contact"
                onClick={() => setOpen(false)}
                className="mt-6 inline-flex items-center gap-2 text-xs tracking-overline uppercase text-onyx bg-cream px-5 py-4 w-fit"
                data-testid="mobile-nav-cta"
              >
                Request Consultation <span>→</span>
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
